/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Stream type values for Freewheel ad calls
 * Used in site section ID (csid) construction for ad targeting.
 * Determined by content type check (isLive()).
 *
 * @example
 * // Used in AbstractFreewheelClass.getStreamType():
 * const streamType = this.isLive()
 *   ? FreewheelStreamType.LIVE
 *   : FreewheelStreamType.VOD;
 *
 * @see {@link AbstractFreewheelClass.createSiteSectionId}
 */
export enum FreewheelStreamType {
	/**
	 * @description Live content stream (live broadcasts, events)
	 */
	LIVE = 'live',

	/**
	 * @description Video on demand stream (pre-recorded content)
	 */
	VOD = 'vod',
}